import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Avatar,
  TextField,
  InputAdornment,
  FormControlLabel,
  Switch,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { get, post } from "src/utils/networkUtils";
import DeleteConfirmDialog from "src/components/game/DeleteConfirmDialog";

export default function GameQuestionsPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [toggle, setToggle] = useState(false);
  const [rows, setRows] = useState(null);
  const [defaultRows, setDefaultRows] = useState(null);
  const [game, setGame] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    if (searchParams.has("game_id")) {
      let gameId = searchParams.get("game_id");
      setGame(gameId);
      get(`/admin/game/${gameId}/questions`).then(function (response) {
        setRows(response.questions);
        setDefaultRows(response.questions);
      });
    } else {
      navigate("/404");
    }
  }, [setSearchParams, searchParams, navigate]);

  const handleRevertSingleQuestionScoring = () => {
    setLoading(true);
    setOpen(null);
    post(`/admin/game/${game}/revert-single-question-scoring`, {
      questionId: openId,
    }).then(function (response) {
      window.location.reload(false);
    });
  };
  const handleGenerateQuestions = () => {
    setLoading(true);

    post(`/admin/game/${game}/generate-team-questions`).then(function (
      response
    ) {
      window.location.reload(false);
    });
  };
  const handleRevertQuestionsScoring = () => {
    setLoading(true);

    post(`/admin/game/${game}/revert-questions-scoring`).then(function (
      response
    ) {
      window.location.reload(false);
    });
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const deleteGameHandler = () => {
    setLoading(true);
    setOpen(false);
    setOpenConfirm(false);
    post(`/admin/game/${game}/delete-question`, { questionId: openId }).then(
      function (response) {
        window.location.reload(false);
      }
    );
  };
  const requestSearch = (searchedVal) => {
    if (searchedVal.length === 0) {
      setRows([...defaultRows]);
    } else {
      const filteredRows = rows.filter((row) => {
        return (
          row.text.toLowerCase().includes(searchedVal.toLowerCase()) ||
          row.targetName.toLowerCase().includes(searchedVal.toLowerCase())
        );
      });
      setRows(filteredRows);
    }
  };

  const handleChangeToggle = (event) => {
    let filteredRows = rows;
    if (event.target.checked) {
      filteredRows = filteredRows.filter((row) => row.isCorrect);
    } else {
      filteredRows = defaultRows;
    }

    setRows([...filteredRows]);
    setToggle(event.target.checked);
  };
  return (
    <>
      <Helmet>
        <title> Bingo Game Questions </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Game Questions
          </Typography>
          {rows !== null && rows.length === 0 && !loading && (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:flip-2-outline" />}
              onClick={() => handleGenerateQuestions()}
              disabled={loading}
            >
              Generate Team Questions
            </Button>
          )}
          <Box>
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:undo-outline" />}
              onClick={() => handleRevertQuestionsScoring()}
              disabled={loading}
              sx={{ mr: 1 }}
            >
              Rever Questions Scoring
            </Button>
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:plus-outline" />}
              onClick={() =>
                navigate(`/dashboard/game/questions/create?game_id=${game}`)
              }
              disabled={loading}
            >
              Create Questions
            </Button>
          </Box>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <Box
                sx={{ display: "flex", justifyContent: "center" }}
                style={{ padding: 20 }}
              >
                <TextField
                  margin="dense"
                  id="kickoff"
                  label="Search"
                  type="email"
                  fullWidth
                  variant="standard"
                  onInput={(e) => {
                    requestSearch(e.target.value);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Iconify icon={"eva:search-outline"} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Box sx={{ p: 2 }}>
                <FormControlLabel
                  control={
                    <Switch checked={toggle} onChange={handleChangeToggle} />
                  }
                  label="Show correct questions"
                />
              </Box>

              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Text</TableCell>
                      <TableCell>Level</TableCell>
                      <TableCell>Logo</TableCell>
                      <TableCell>Correct</TableCell>
                      <TableCell>Cells</TableCell>
                      <TableCell>Cells Scores</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.questionId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.targetName} {row.text}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.level}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {process.env.REACT_APP_LEAGUE_NAME === "nhl" ? (
                            <Avatar
                              alt="Logo"
                              src={
                                row.type === "team"
                                  ? `https://www-league.nhlstatic.com/images/logos/teams-current-primary-light/${row.logoId}.svg`
                                  : `https://cms.nhl.bamgrid.com/images/headshots/current/168x168/${row.logoId}.jpg`
                              }
                            />
                          ) : null}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.isCorrect ? (
                            <Iconify
                              icon={"eva:checkmark-circle-2-outline"}
                              sx={{ color: "green" }}
                            />
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.cellsCount}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.scoredCellsCount}/{row.correctCellsCount}
                        </TableCell>
                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleOpenMenu}
                            id={row.questionId}
                          >
                            <Iconify icon={"eva:more-vertical-fill"} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>

      <DeleteConfirmDialog
        openConfirm={openConfirm}
        setOpenConfirm={setOpenConfirm}
        deleteGameHandler={deleteGameHandler}
      />
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        {/**
         * 
         * <MenuItem
          sx={{ color: "error.main" }}
          onClick={() => setOpenConfirm(true)}
        >
          <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
         */}
        <MenuItem onClick={() => handleRevertSingleQuestionScoring()}>
          <Iconify icon={"eva:undo-outline"} sx={{ mr: 2 }} />
          Revert Scor.
        </MenuItem>
      </Popover>
    </>
  );
}
